enum WorkspaceProjectImpactFrameworkComponentRiskImpactType {
  'Low Impact' = 'Low Impact',
  'Medium Impact' = 'Medium Impact',
  'High Impact' = 'High Impact',
  'Critical Impact' = 'Critical Impact',
}

export default WorkspaceProjectImpactFrameworkComponentRiskImpactType
